module.exports = __webpack_public_path__ + "img/pomotion.c731242d.jpg";